import { getLogsAPI } from "@/apis/admin-api"
import { create } from "zustand"
import { createListStore } from "../create-list-store-util"

export const logStore = create(createListStore(getLogsAPI))
